import _ from "lodash";

export const isMobile = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  try {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Check for mobile devices using comprehensive regex patterns
    const mobileRegex =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|kindle|silk|playbook|bb10|meego/i;

    const isMobileDevice = mobileRegex.test(userAgent.toLowerCase());

    // Check for touch capability (additional indicator)
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // Check for small screen size as additional confirmation
    const isSmallScreen = window.innerWidth < 768;

    // Safari's device emulator doesn't change user agent, so we need to be smarter
    // Check if it's a touch device with mobile-like dimensions (even if not small)
    const isMobileDimensions = window.innerWidth <= 1024 && window.innerHeight >= window.innerWidth;

    // Return true if:
    // 1. User agent indicates mobile, OR
    // 2. Touch device with small screen, OR
    // 3. Touch device with mobile-like dimensions (portrait or small landscape)
    const result = isMobileDevice || (isTouchDevice && (isSmallScreen || isMobileDimensions));

    return result;
  } catch (error) {
    return false;
  }
}

export const isTablet = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  try {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Tablet-specific patterns
    const tabletRegex = /ipad|android(?!.*mobile)|tablet|kindle|silk|playbook/i;

    const isTabletUA = tabletRegex.test(userAgent.toLowerCase());

    // Check for touch device with tablet-like dimensions (768px - 1024px width)
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isTabletDimensions = window.innerWidth >= 768 && window.innerWidth <= 1024;

    // Return true if user agent indicates tablet OR touch device with tablet dimensions
    const result = isTabletUA || (isTouchDevice && isTabletDimensions);

    return result;
  } catch (error) {
    return false;
  }
}

export const isDesktop = (): boolean => {
  return !isMobile();
}

export const isMobileServer = (userAgent: string): boolean => {
  if (!userAgent) return false;

  const mobileRegex =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet|kindle|silk|playbook|bb10|meego/i;

  return mobileRegex.test(userAgent.toLowerCase());
}

export const getDeviceInfo = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      browser: "unknown",
      os: "unknown",
    };
  }

  try {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const ua = userAgent.toLowerCase();

    // Detect OS
    let os = "unknown";
    if (/windows/i.test(ua)) os = "windows"
    else if (/mac os/i.test(ua)) os = "macos"
    else if (/linux/i.test(ua)) os = "linux"
    else if (/android/i.test(ua)) os = "android"
    else if (/iphone|ipad|ipod/i.test(ua)) os = "ios";

    // Detect browser
    let browser = "unknown";
    if (/chrome/i.test(ua) && !/edge|edg/i.test(ua)) browser = "chrome"
    else if (/safari/i.test(ua) && !/chrome/i.test(ua)) browser = "safari"
    else if (/firefox/i.test(ua)) browser = "firefox"
    else if (/edge|edg/i.test(ua)) browser = "edge"
    else if (/opera|opr/i.test(ua)) browser = "opera";

    return {
      isMobile: isMobile(),
      isTablet: isTablet(),
      isDesktop: isDesktop(),
      browser,
      os,
      platform: _.get(navigator, 'platform', 'unknown')
    }
  } catch (error) {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      browser: "unknown",
      os: "unknown",
      platform: "unknown"
    }
  }
}
